import { render, staticRenderFns } from "./ProfileRoot.vue?vue&type=template&id=66c67de1&"
import script from "./ProfileRoot.vue?vue&type=script&lang=js&"
export * from "./ProfileRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports